const CardBody = {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
};

export const CardBodyComponent = {
  components: {
    CardBody,
  },
};

